import { SalePlans } from './SalePlans.main';

export { SalePlans };
